<template>
    <div>
        <div class="nav">
            <page-navigation v-bind:step="currentStep"></page-navigation>
        </div>
        <div class="content_main" style="overflow: hidden;">
            <h3 class="line_orange" style="float: left;">周补货频次设置</h3>
            <div id="root" style="float: left;">
                   <div class="element-a" @mouseover="gifShow()" @mouseleave="gifHidden()" style="float: right; padding-left:10px; padding-top:1px;">
                      <img class="information"  src="../../assets/tipp_icon.png" style="float: right;">
                      </div>
                       <div class="gif-wrap" id="gif" v-show="ifShowB"
             @mouseover="gifMouseOver" @mouseleave="gifMouseLeave">
                         <img class="gif" src="../../assets/step 3.gif">
                     </div>
                  </div>

            <div class="table_panel">
                <ul class="table_panel_container">
                    <li class="table_column table_name">
                        <ul>
                            <li>星期日</li>
                            <li>星期一</li>
                            <li>星期二</li>
                            <li>星期三</li>
                            <li>星期四</li>
                            <li>星期五</li>
                            <li>星期六</li>
                        </ul>
                    </li>
                    <li v-bind:class="{table_last_column:!weekitem.ifShow,table_half_column:weekItem == 0}" class="table_column" v-for="(weekitem,weekItem) in replenishment">
                        <ul>
                            <li class="column_title" v-on:click="checkList(weekitem,weekItem)">
                                <img v-if="weekitem.ifShow" src="../../assets/calendar.png" alt="">
                                <span class="column_name">{{weekitem.title}}</span>
                            </li>
                            <!--<li class="content_list" v-bind:class="[(weekitem.default.indexOf(index) != -1 && weekitem.ifShow) ?'checked':'check']" v-for="(item,index) in week">Y</li>-->
                            <li class="content_list" v-on:click="checkOne(weekitem,index,weekItem)" v-bind:class="{checked:(weekitem.default.indexOf(index) != -1 && weekitem.ifShow),'check':weekitem.default.indexOf(index) == -1,'default':(weekitem.default.indexOf(index) != -1 && !weekitem.ifShow)}" v-for="(item,index) in week">
                              <div v-if="weekItem == 0" class="rect_bg">
                                <span v-on:click="checkHalf(weekitem,index,'+')" class="top_half" v-bind:class="{half_active:weekitem.default.indexOf(index) != -1 && weekitem.default.indexOf('+') != -1}">Y</span>
                                <span v-on:click="checkHalf(weekitem,index,'-')" class="bottom_half" v-bind:class="{half_active:weekitem.default.indexOf(index) != -1 && weekitem.default.indexOf('-') != -1}">Y</span>
                              </div>
                              <span v-if="weekItem != 0">Y</span>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div class="bottom_footer">
                <span class="black_color" v-on:click="toDefault()">恢复默认数据</span>
                <div class="bottom_right">
                    <input type="checkbox" name="default" id="default">
                    <label for="default" v-on:click="setToDefault()">设置为默认</label>
                </div>
                <button class="btn btn_black_bg" v-on:click="calculate()">保存</button>
            </div>
        </div>
        <page-footer v-bind:footerStatus="status" v-bind:next="nextUrl" v-bind:prev="prevUrl"></page-footer>
        <tip v-if="ifShow  && sendMessage.length > 0 " v-bind:status="sendStatus" v-bind:message="sendMessage"></tip>
    </div>
</template>
<script>
import PageNavigation from "@/components/common/PageNavigation";
import PageFooter from "@/components/common/PageFooter";
import Tip from "@/components/common/tip";
import { mapState, mapActions } from "vuex";
import {
  getWeeksList,
  setToDefaultWeeks,
  weekCalculate,
  recoverDefaultWeeks
} from "../../util/api.js";

export default {
  name: "SettingWeeks",
  components: { PageNavigation, PageFooter, Tip },
  data() {
    return {
    ifShowB: false,
    BFocused: false,
      status: {
        type: "config",
        status: "middle"
      },
      prevUrl: "SettingParameter",
      nextUrl: "Calculate",
      currentStep: 3,
      ifChecked: false,
      week: ["", "", "", "", "", "", ""],
      defaultList: [
        {
          title: "0.5/7d",
          default: [0,"+"],
          ifShow: true
        },
        {
          title: "1/7d",
          default: [0],
          ifShow: true
        },
        {
          title: "2/7d",
          default: [1, 2],
          ifShow: true
        },
        {
          title: "3/7d",
          default: [0, 1, 3],
          ifShow: true
        },
        {
          title: "4/7d",
          default: [1, 2, 4, 5],
          ifShow: true
        },
        {
          title: "5/7d",
          default: [1, 2, 3, 4, 5],
          ifShow: true
        },
        {
          title: "6/7d",
          default: [1, 2, 3, 4, 5, 6, 7],
          ifShow: false
        },
        {
          title: "7/7d",
          default: [0, 1, 2, 3, 4, 5, 6, 7],
          ifShow: false
        }
      ],
      sendStatus: false,
      sendMessage: ""
    };
  },
  computed: mapState({
    replenishment: state => state.weekList,
    ifShow: state => state.ifShowMessage
  }),
  mounted: function() {
    let that = this;
    that.$store.commit("getIfShowMessage", false);
    that.$store.commit("getWeekList", []);
    var dealData = function(data, i) {
      let defaultDay = [];
      let g = data.replace(/0/, "").split("");
      g.forEach((item, j) => {
        defaultDay.push(i == 0 && j == 1 ? item : item % 7);
      });
      return defaultDay;
    };
    getWeeksList({ userId: this.getCookie("rstuserId") })
      .then(function(res) {
        if (res.data) {
          console.log(res.data);
          let data = res.data.result;
          let result = [];
          let array = [
            "half",
            "one",
            "two",
            "three",
            "four",
            "five",
            "six",
            "seven"
          ];
          array.forEach((element, i) => {
            result.push({
              title: i == 0 ? "0.5/7d" : i + "/7d",
              default: dealData(data[element], i),
              ifShow:
                data[element].length == 1 && data[element][0] == "0"
                  ? false
                  : true
            });
          });
          console.log(result);
          that.$store.commit("getWeekList", result);
          console.log(that.replenishment);
        } else {
          that.$store.commit("getIfShowMessage", true);
          that.sendStatus = false;
          that.sendMessage = "获取周补货频次失败";
        }
      })
      .catch(function(error) {
        console.log(error);
        that.$store.commit("getIfShowMessage", true);
        that.sendStatus = false;
        that.sendMessage = "获取周补货频次失败";
      });
  },
  methods: {
    getCookie: function(name) {
      var arr;
      var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
      else return null;
    },  
     gifShow() {
        this.ifShowB = true;

      },

      gifHidden() {
        
   
        if (!this.BFocused) {
          this.ifShowB = false;
        } else
          this.ifShowB = true;
      },

     
      gifMouseOver() {
        this.ifShowB = true;
        this.BFocused = true;
      },

      gifMouseLeave() {
        
       
        this.BFocused = false;
        this.ifShowB = false;
      },
    checkList: function(weekitem, index) {
      weekitem.ifShow = !weekitem.ifShow;
      if(!weekitem.ifShow){
        weekitem.default = [];
      }else{
        switch(index){
          case 0: 
            weekitem.default = [0,"+"];
            break;
          case 1: 
            weekitem.default = [0];
            break;
          case 2: 
            weekitem.default = [1, 4];
            break;
          case 3: 
            weekitem.default = [0, 1, 3];
            break;
          case 4: 
            weekitem.default = [1, 2, 4, 5];
            break;
          case 5: 
            weekitem.default = [1, 2, 3, 4, 5];
            break;
          case 6: 
            weekitem.default = [1, 2, 3, 4, 5, 6];
            break;
          case 7:
            weekitem.default = [0,1, 2, 3, 4, 5, 6];
            break;
        }
      }
      console.log(this.replenishment);
      this.$store.commit("getWeekList", this.replenishment);
    },
    checkOne: function(oneweek, index, weekIndex) {
      if(weekIndex == 0){
        return;
      }
      else if(weekIndex == 1){
        oneweek.default = [index];
        oneweek.ifShow = true;
        return;
      }

      if (!oneweek.ifShow) {
        oneweek.default = [index];
        oneweek.ifShow = true;
      } else {
        if (oneweek.default.indexOf(index) != -1) {
          //删除
          oneweek.default.forEach((element, i) => {
            if (element == index) {
              oneweek.default.splice(i, 1);
            }
          });
        } else {
          //添加
          if (
            (weekIndex != 0 && weekIndex > oneweek.default.length) ||
            (weekIndex == 0 && oneweek.default.length == 0)
          ) {
            oneweek.default.push(index);
          }
        }
      }
    },
    checkHalf:function(oneweek,index,type){
      if(!oneweek.ifShow){
        oneweek.ifShow = !oneweek.ifShow;
      }
      oneweek.default = [index];
      oneweek.default.push(type);
    },
    toDefault: function() {
      //this.$store.commit("getWeekList", JSON.parse(JSON.stringify(this.defaultList)));
      let that = this;
      console.log(this.defaultList);
      var dealData = function(data, i) {
        let defaultDay = [];
        let g = data.replace(/0/, "").split("");
        g.forEach((item, j) => {
          defaultDay.push(i == 0 && j == 1 ? item : item % 7);
        });
        return defaultDay;
      };
      recoverDefaultWeeks({userId:this.getCookie('rstuserId')})
        .then(function(res){
          let data = res.data.result;
          let result = [];
          let array = [
            "half",
            "one",
            "two",
            "three",
            "four",
            "five",
            "six",
            "seven"
          ];
          array.forEach((element, i) => {
            result.push({
              title: i == 0 ? "0.5/7d" : i + "/7d",
              default: dealData(data[element], i),
              ifShow:
                data[element].length == 1 && data[element][0] == "0"
                  ? false
                  : true
            });
          });
          console.log(result);
          that.$store.commit("getWeekList", result);
          console.log(that.replenishment);
        })
        .catch(function(error){
          console.log(error);
        })
    },
    setToDefault: function() {
      this.ifChecked = !this.ifChecked;
    },
    calculate: function() {
      let getcount = 0;
      let that = this;
      for(var i = 0 ; i < this.replenishment.length ; i++){
        let element = this.replenishment[i];
        if(element.default.length == 0 && !element.ifShow){
          getcount++;
        }
        else if(i != 0 && (element.default.length != 0 && element.default.length < i || element.default.length == 0 && element.ifShow)){
          that.$store.commit("getIfShowMessage", true);
          that.sendStatus = false;
          that.sendMessage = "周补货频次"+i+"/7d，只能选择"+ i +"个补货日期";
          return;
        }
      }
      if(getcount == 8){
          that.$store.commit("getIfShowMessage", true);
          that.sendStatus = false;
          that.sendMessage = "至少选择一个周补货频次参数保存，进行计算";
          return;
      }
      let data = {
        userId: this.getCookie("rstuserId"),
        half: this.replenishment[0].default.length != 0 ? this.replenishment[0].default.join("").replace(/0/, "7"):"0",
        one: this.replenishment[1].default.length != 0 ?this.replenishment[1].default.join("").replace(/0/, "7"):"0",
        two: this.replenishment[2].default.length != 0 ?this.replenishment[2].default.join("").replace(/0/, "7"):"0",
        three: this.replenishment[3].default.length != 0 ?this.replenishment[3].default.join("").replace(/0/, "7"):"0",
        four: this.replenishment[4].default.length != 0 ?this.replenishment[4].default.join("").replace(/0/, "7"):"0",
        five: this.replenishment[5].default.length != 0 ?this.replenishment[5].default.join("").replace(/0/, "7"):"0",
        six: this.replenishment[6].default.length != 0 ?this.replenishment[6].default.join("").replace(/0/, "7"):"0",
        seven: this.replenishment[7].default.length != 0 ?this.replenishment[7].default.join("").replace(/0/, "7"):"0",
        isDefault: this.ifChecked == true ? 1 : 0
      };
      console.log(data);
      weekCalculate(data)
        .then(function(res) {
          that.$store.commit("getIfShowMessage", true);
          if (res.data.success) {
            that.sendStatus = true;
            that.sendMessage = that.ifChecked == true ? "保存且修改默认成功":"保存成功";
          }else{
            that.sendStatus = false;
            that.sendMessage = "保存失败";
          }
          console.log(res);
        })
        .catch(function(err) {
          console.log(err);
          that.$store.commit("getIfShowMessage", true);
          that.sendStatus = false;
          that.sendMessage = "保存失败";
        });
    }
  }
};
</script>
<style scoped>
li {
  list-style: none;
}
.nav {
  padding: 0.1rem 0 0.1rem 0;
}
@media screen and (max-height: 650px) {
    .content_main {
      background-color: #fff;
      width: 10rem;
      height: 5.99rem;
      margin: 0 auto;
      margin-bottom: 0.77rem;
      padding-top: 0.19rem;
      box-shadow: 0 0 5px -3px #000;
      position: relative;
    }
}
@media screen and (min-height: 650px) {
    .content_main {
      background-color: #fff;
      width: 10rem;
      height: 5.99rem;
      padding-top: 0.19rem;
      margin-top: 0.2rem;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      box-shadow: 0 0 5px -3px #000;
    }
}
.content_main h3 {
  text-align: left;
}
.line_orange:before {
  display: inline-block;
  width: 0.04rem;
  height: 0.24rem;
  vertical-align: middle;
  content: "";
  margin-right: 0.24rem;
  background-color: #fa5400;
}
.table_panel {
  padding: 0.53rem 0 0 1.59rem;
}
.table_panel_container {
  overflow: hidden;
}
.table_column {
  float: left;
  padding-right: 0.08rem;
}
.table_name {
  padding-top: 0.6rem;
  padding-right: 0.2rem;
}
.table_name li {
  height: 0.43rem;
  line-height: 0.43rem;
}
.table_column li {
  margin-bottom: 0.08rem;
}
.column_title {
  position: relative;
  cursor: pointer;
}
.column_title img {
  vertical-align: middle;
  width: 0.62rem;
}
.column_name {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  line-height: 0.52rem;
  color: #fa5400;
}
.content_list,
.table_last_column li {
  width: 0.6rem;
  height: 0.43rem;
  line-height: 0.43rem;
  cursor: pointer;
}
.content_list .top_half,.content_list .bottom_half{
  display: block;
  height: 0.215rem;
  line-height: 0.25rem;
}
.table_half_column .content_list{
  background-color: #fff;
}
.table_half_column .top_half:hover,.table_half_column .bottom_half:hover{
  background-color: #fdcbb2;
}
.table_last_column .check,.table_last_column .default,.table_last_column .half_active{
  background: #e6e6e6;
}
.checked .rect_bg{
  background-image: url(../../assets/rect_bg.png);
  background-position: center;
}
.checked .active,.half_active{
  background-color: #fa5400;
}
.table_last_column li {
  border: 0;
  background-color: #e6e6e6;
  color: #e6e6e6;
}
.table_last_column .column_title {
  height: 0.52rem;
  color: #000;
  line-height: 0.52rem;
  background-color: #fff;
  border: 1px solid #777;
}
.table_last_column .column_name{
  color: #000;
}
.checked {
  background-color: #fa5400 !important;
  color: #fff;
  border: 0;
}
.check,
.default {
  background-color: #fff;
  color: #fff;
  border: 1px solid #d4d4d4;
}
.column_title:hover ~ .default,
.check:hover {
  background-color: #fdcbb2;
  color: #fff;
  border: 0;
}
.table_half_column .column_title:hover ~ .default,
.table_half_column .check:hover {
  background-color: #fff;
  border: 1px solid #d4d4d4;
}
.bottom_footer {
  padding: 0.27rem 1.12rem 0 1.1rem;
  display: flex;
  align-items: center;
}
.black_color {
  color: #000;
  text-decoration: underline;
  cursor: pointer;
}
.bottom_right {
  flex: 1;
  text-align: right;
}
.btn {
  width: 1.17rem;
  height: 0.46rem;
  font-size: 0.15rem;
  border: 0;
  border-radius: 2px;
  cursor: pointer;
}
.btn_black_bg {
  color: #fff;
  background-color: #000;
}
.element-a:hover{
            cursor: pointer;
            opacity: 1;
        }
.gif {
        width: 800px;
        height: 480px;
        }
.gif-wrap{

    font-size: 1rem;
    position: absolute;
    border-radius: 10px;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: 99;
    -webkit-transition:all 1.0s ease-in-out;
    -moz-transition:all 1.0s ease-in-out;
    -o-transition:all 1.0s ease-in-out;
    -ms-transition:all 1.0s ease-in-out;
    transition:all 1.0s ease-in-out;
}    
.gif-wrap:hover{
    cursor: pointer;
    opacity: 1;
}
input {
  display: none;
}
input + label {
  display: flex;
  flex-direction: row;
}
input + label:hover {
  color: #3956ca;
}
input + label::before {
  content: "";
  background: url(../../assets/check.png) no-repeat;
  width: 0.21rem;
  height: 0.21rem;
  display: block;
  padding-right: 0.07rem;
  background-size: 0.19rem 0.19rem;
}
input:checked + label::before {
  background: url(../../assets/checked.png) no-repeat;
  background-size: 0.19rem 0.19rem;
}
.bottom_right label {
  float: right;
  padding-right: 0.15rem;
  cursor: pointer;
  line-height: 0.21rem;
  height: 0.21rem;
}
</style>




// WEBPACK FOOTER //
// src/components/page/SettingWeeks.vue